/**
 * appendTo utility
 */
module.exports = appendTo;

var ensureImported = require('./util/ensureImported');

/**
 * Append a node to a target element and return the appended node.
 *
 * @param  {SVGElement} element
 * @param  {SVGElement} node
 *
 * @return {SVGElement} the appended node
 */
function appendTo(element, target) {
  target.appendChild(ensureImported(element, target));
  return element;
}


// WEBPACK FOOTER //
// ./~/tiny-svg/lib/appendTo.js